import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification, isMobile } from "../../../../helpers";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Form, Row, Col, Button, Input, notification as Notification, AutoComplete, Spin } from "antd";

import Map from '../../components/GoogleMaps/Map';

const { Option } = AutoComplete;

let searchTimeout = null;
let mapsTimeout = null;


class ContactEdit extends Component {

    constructor(props) {
        super(props);

        this.endpoint = { keyOne: "contact", idOne: this.props.match.params.id };
        this.isEdit = this.props.match.params.id;
        this.state = {
            form: {},
            loadings: {
                submit: false,
                data: false,
                proxyuser: false,
                proxyusersubmit: false,
                search: false
            },
            isShowModal: false,
            values: {
                searchLocations: []
            }
        };
        this.formRef = React.createRef();
        this.initMap = this.initMap.bind(this);

    }

    componentDidMount() {

        if (this.props.account.mapsClient === "Yandex") {
            try {
                this.map.destroy();
                this.map = null;
            } catch (e) {
            }

            this.ymap = window.ymaps;

            setTimeout(() => {
                this.ymap.ready(this.initMap);
            }, 3500);
        }

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        if (this.isEdit) {
            this.getData();
        }
    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint
        })).then(response => {
            loadings.data = false;
            this.setState({
                form: response, loadings
            });


        })
            .catch(error => {

                loadings.data = false;
                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    initMap() {

        let _this = this;

        var coordinates = [41.045930450756735, 29.033413529100827];
        let { form } = this.state;

        if (form.latitude) {
            coordinates = [form.latitude, form.longitude]
        }

        this.map = new this.ymap.Map('map-yandex', {
            center: coordinates,
            zoom: 13,
            controls: ['fullscreenControl']
        }, {
            buttonMaxWidth: 300
        });

        var zoomControl = new this.ymap.control.ZoomControl({
            options: {
                size: "small"
            }

        });
        this.map.controls.add(zoomControl);

        var placemark = null;

        placemark = new this.ymap.Placemark(coordinates, {
            iconCaption: ''
        }, {
            preset: 'islands#violetDotIconWithCaption',
            draggable: true,
            iconColor: '#32a852'
        });

        this.map.geoObjects.add(placemark);

        placemark.events.add('dragend', function (e) {

            var coordinates = e.originalEvent.target.geometry._coordinates;
            _this.onSelectAddress(`${coordinates[0]}|${coordinates[1]}`);

        }).add('submit', function () {
        });

        setTimeout(() => {
            placemark.geometry.setCoordinates(coordinates)
            this.map.setCenter(coordinates, 13);
        }, 1000);
    }

    addressSearchQuery = (query) => {

        let { values } = this.state;

        if (query === null || query === '' || query === undefined) {
            values.searchLocations = [];
            this.setState({ values });
            return;
        }

        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {

            let { loadings } = this.state;
            loadings.search = true;
            this.setState({ loadings })

            let endpoint = { keyOne: `googlemaps/autocomplete?keyword=${query}` };
            this.props
                .dispatch(
                    actions.definitions.getDatas({
                        ...endpoint,
                    })
                )
                .then((response) => {
                    values.searchLocations = response;
                    loadings.search = false;
                    this.setState({ values, loadings });
                });
        }, 500);
    };

    onSelectAddress = (value, option) => {

        const coordinates = value.split('|');

        let { form, loadings } = this.state;
        loadings.search = true;

        form.latitude = coordinates[0];
        form.longitude = coordinates[1];

        this.setState({ loadings, form });


        let endpoint = { keyOne: `googlemaps/placedetailbylocation?latitude=${coordinates[0]}&longitude=${coordinates[1]}` };

        if (this.props.account.mapsClient === "Google") {
            endpoint = { keyOne: `googlemaps/placedetailbyId?placeId=${coordinates[0]}` };
        }

        this.props
            .dispatch(
                actions.definitions.getDatas({
                    ...endpoint,
                })
            )
            .then((response) => {

                if (this.props.account.mapsClient === "Google") {
                    this.onPlaceDetailByLocation(response.latitude, response.longitude)
                } else {
                    setTimeout(() => {
                        form.address = response.address;
                        loadings.search = false;
                        this.setState({ form, loadings }, () => {
                            this.refreshMap();
                        });

                        this.formRef.current.setFieldsValue({
                            address: response.address,
                        });
                    })
                }

            });

    }

    onPlaceDetailByLocation = (latitude, longitude) => {

        clearTimeout(mapsTimeout);
        mapsTimeout = setTimeout(() => {

            let { form, loadings } = this.state;
            loadings.search = true;


            form.latitude = latitude;
            form.longitude = longitude;

            this.setState({ loadings, form });

            let endpoint = { keyOne: `googlemaps/placedetailbylocation?latitude=${latitude}&longitude=${longitude}` };

            this.props
                .dispatch(
                    actions.definitions.getDatas({
                        ...endpoint,
                    })
                )
                .then((response) => {
                    setTimeout(() => {
                        form.address = response.address;
                        loadings.search = false;
                        this.formRef.current.setFieldsValue({
                            address: response.address,
                        });
                        this.setState({form,loadings})
                    })
                });

        }, 500)

    }

    refreshMap = () => {

        let { loadings } = this.state;
        loadings.map = true;

        this.setState({ loadings }, () => {
            setTimeout(() => {
                try {
                    this.map.destroy();
                    this.map = null;
                } catch (e) {
                }

                this.ymap.ready(this.initMap);
                loadings.map = false;
                this.setState({ loadings })
            }, 500);
        })
    }

    fetch = (values) => {

        let { loadings, form } = this.state;

        var param = values;
        param.latitude = form.latitude;
        param.longitude = form.longitude;

        loadings.submit = true;
        this.setState({ loadings });

        var method = this.props.match.params.id ? "updateData" : "addData"

        this.props
            .dispatch(
                actions.definitions[method]({
                    ...this.endpoint,
                    data: param,
                })
            )
            .then((response) => {
                loadings.submit = false;

                this.setState({
                    loadings,
                });

                Notification.success({
                    message: errorMessageNotification(response),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 3,
                });


                setTimeout(() => {
                    this.props.history.push(
                        "/app/contacts"
                    );
                }, 1000);

            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };



    render() {

        let { form, loadings, values } = this.state;

        return (

            <div className="form-container"
                style={{ maxWidth: 800, width: 800 }}
            >

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='heading'><strong>{this.isEdit ? `Kişi Düzenle` : `Kişi Ekle`}</strong></div>
                }

                {
                    !loadings.data &&
                    <Form layout="vertical" className='form-box' ref={this.formRef}
                        style={{ maxWidth: 800, width: 800 }}
                        onFinish={this.fetch}>

                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("name", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.name ? form.name : null}
                                >
                                    <Input
                                        placeholder={i18n.t("name", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("lastname", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="lastname"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.lastname ? form.lastname : null}

                                >
                                    <Input
                                        placeholder={i18n.t("lastname", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("phoneNumber", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="phoneNumber"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.phoneNumber ? `+${form.phoneNumber}` : null}

                                >
                                    {/* <Input
                                        placeholder={i18n.t("+90 555 555 55 55", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    /> */}

                                    <PhoneInput
                                        country="TR"
                                        placeholder="+90 555 555 55 55"
                                    // value={value}
                                    // onChange={setValue} 
                                    />

                                </Form.Item>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label={`${i18n.t("email", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="email"
                                    rules={[
                                        {
                                            required: false,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.email ? form.email : null}

                                >
                                    <Input
                                        placeholder={i18n.t("email", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={`${i18n.t("address", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="address"
                                    rules={[
                                        {
                                            required: false,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                    initialValue={form.address ? form.address : null}

                                >
                                    <AutoComplete
                                        dropdownMatchSelectWidth={252}
                                        onSelect={this.onSelectAddress}
                                        onSearch={this.addressSearchQuery}
                                        loading={loadings.search}
                                        placeholder={`${i18n.t("Adresi buraya yazarak aratabilirsiniz", {
                                            lng: this.props.currentLanguage,
                                        })}`}
                                    >
                                        {values.searchLocations.map((searchLocation) => (
                                            <Option key={searchLocation.placeId} value={searchLocation.placeId}>
                                                {searchLocation.address}
                                            </Option>
                                        ))}
                                    </AutoComplete>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={`${i18n.t("Akıllı Harita", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="maps"
                                >

                                    {
                                        this.props.account.mapsClient === "Yandex" ?
                                            <div id="map-yandex" className="map" style={{ width: "%100", height: 229 }} />
                                            :
                                            <Map data={form}
                                                onChangeMap={this.onPlaceDetailByLocation}
                                            />

                                    }

                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item className="form-item-submit">
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        className="ant-btn width-100"
                                        style={{ height: 40 }}
                                        loading={this.state.loadings.submit}
                                    >
                                        Kişiyi Kaydet
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(ContactEdit);


// WEBPACK FOOTER //
// ./src/components/App/Views/Contact/ContactEdit.js